import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import * as contracts from '../contracts';
import { AccountOwnerMapper } from '../account-owner-rest/mappers';
import { accountOwnerCollection } from './account-owner-collection';

@Injectable()
export class AccountOwnerMockService implements contracts.IAccountOwnerService {
  getAccountOwnerList(
    request: contracts.GetAccountOwnerListRequest
  ): Observable<contracts.GetAccountOwnerListResponse> {
    const response = new contracts.GetAccountOwnerListResponse();

    let items = accountOwnerCollection;
    if (request && request.name) {
      const query = request.name.trim().toLowerCase();
      items = items.filter((owner) => owner.name.toLowerCase().includes(query));
    }

    response.entities = items.map(AccountOwnerMapper.Instance().accountOwnerDtoToAccountOwner);

    return of(response);
  }
}
